import React, { Component } from "react";
import { Card, CardContent, CardHeader } from "@mui/material";
import AnalyticsHeader from "visual-components/analyticsDashboard/analytics-header";
import ColumnGrouped from "visual-components/util/graphs/column-grouped";

export default class StatsByPartnerCard extends Component {
  toggleItem = (type) => {
    const { hideMap } = this.props.data;
    hideMap[type] = !hideMap[type];

    store.dispatch({
      model: "analyticsCampaign",
      type: "UPDATE_ATTR",
      data: {
        campaignStatsByPartner: {
          ...this.props.data,
          hideMap: hideMap,
        },
      },
    });
  };

  render() {
    const { data, canViewSms, started } = this.props;

    let {
      data: { items },
    } = this.props;

    if (!canViewSms) {
      items = items.filter((item) => item.name !== "smsSubscribers");
    }

    return (
      <Card>
        <CardHeader title={<AnalyticsHeader title="Stats by Partner" />} />
        <CardContent>
          <ColumnGrouped data={data} started={started} toggleItem={this.toggleItem} />
        </CardContent>
      </Card>
    );
  }
}
